import { FC, useRef } from 'react';
import CaseStudyCardProProfile from '@z-components/organisms/CaseStudyCardProProfile';
import { useSelector } from 'react-redux';
import {
  caseStudiesAllSelector,
  caseStudiesPageSizeSelector,
  caseStudiesSelector,
  caseStudiesTotalCountSelector,
} from 'modules/marketing-pages/duck/selectors';

import CardList from 'components/organisms/CardList';
import { CaseStudy } from '@z-components/organisms/CaseStudyCardProProfile/types';

interface Props {
  jobType?: string;
  profileCaseStudyUrl?: string;
  title?: {
    base?: string;
    prefix?: string;
  };
  variant?: string;
}

const ListCaseStudies: FC<Props> = ({
  title = {
    base: '事例',
    prefix: '',
  },
  profileCaseStudyUrl = '',
  variant = '',
}) => {
  const totalCaseStudies = useSelector(caseStudiesTotalCountSelector);
  const caseStudies = useSelector(caseStudiesSelector);
  const pageSize = useSelector(caseStudiesPageSizeSelector);
  const sectionContainerRef = useRef<HTMLDivElement>(null);
  const caseStudiesAll = useSelector(caseStudiesAllSelector);

  // TODO: filter caseStudies & caseStudiesAll by jobType here.

  return (
    // NOTE: 1 is a dummy value
    //   why pass dummy value?: to avoid unexpected issues arise from modifying the component
    //   but in case, props `currentPage` being unnecessary as the paging functionality is no longer needed
    <CardList
      cardRenderer={(dataItem) => (
        <CaseStudyCardProProfile caseStudy={dataItem as CaseStudy} hasBoxShadow={false} />
      )}
      currentPage={1}
      data={caseStudies}
      dataAll={caseStudiesAll}
      loadingPlaceholderHeight="60vh"
      pageQueryParamName="caseStudyPage"
      pageSize={pageSize}
      ref={sectionContainerRef}
      profileCaseStudyUrl={profileCaseStudyUrl}
      testId="list-case-studies-for-pro-profile"
      title={title.base}
      titlePrefix={title.prefix}
      totalItems={totalCaseStudies}
      usage={'pro-profile-case-study'}
      variant={variant}
    />
  );
};

export type { Props as ListCaseStudiesProps };
export default ListCaseStudies;
